import { GetDoctorSpecialistListRes } from "./Model";
export const GET_DOCTOR_SPECIALITY_LIST_LOADING = "GET_DOCTOR_SPECIALITY_LIST_LOADING";
export const GET_DOCTOR_SPECIALITY_LIST_SUCCESS = "GET_DOCTOR_SPECIALITY_LIST_SUCCESS";
export const GET_DOCTOR_SPECIALITY_LIST_FAIL = "GET_DOCTOR_SPECIALITY_LIST_FAIL";
export const GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_MSG =
  "GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_MSG";
export const GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_RES =
  "GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_RES";

export interface GetDoctorSpecialityListState {
  getDoctorSpecialityListRes: GetDoctorSpecialistListRes;
  loading: boolean;
  successMsg: string;
  errorMsg: string;
  status: number;
}
export interface GetDoctorSpecialityListLoading {
  type: typeof GET_DOCTOR_SPECIALITY_LIST_LOADING;
  loading: boolean;
}
export interface GetDoctorSpecialityListSuccess {
  type: typeof GET_DOCTOR_SPECIALITY_LIST_SUCCESS;
  payload: GetDoctorSpecialistListRes;
  successMsg: string;
}
export interface GetDoctorSpecialityListFail {
  type: typeof GET_DOCTOR_SPECIALITY_LIST_FAIL;
  payload: GetDoctorSpecialistListRes;
  errorMsg: string;
  status: number;
}
export interface GetDoctorSpecialityListUpdateAPIMsg {
  type: typeof GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_MSG;
  payload: GetDoctorSpecialistListRes;
  successMsg: string;
  errorMsg: string;
  status: number;
}
export interface GetDoctorSpecialityListUpdateAPIRes {
  type: typeof GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_RES;
  payload: GetDoctorSpecialistListRes;
  successMsg: string;
  errorMsg: string;
  status: number;
}

export type GetDoctorSpecialityListActionTypes =
  | GetDoctorSpecialityListLoading
  | GetDoctorSpecialityListSuccess
  | GetDoctorSpecialityListFail
  | GetDoctorSpecialityListUpdateAPIMsg
  | GetDoctorSpecialityListUpdateAPIRes;
